import React, { useEffect, useState } from "react";
import { DefaultTheme, ThemeProvider } from "styled-components";
import { connect } from "react-redux";
import breakpoints from "../../../styles/breakpoints";
import colors from "../../../styles/colors";
import fonts from "../../../styles/fonts";
import fontSizes from "../../../styles/fontSizes";
import primaryTheme from "../../../styles/theme";
import { IState } from "../../../App/reducer";
import { isEmpty, isNil } from "ramda";
import { getThemeColorsFromLessString, getThemeDefaultColor } from "../../../utils/theme";
import { IStyle } from "../../../Types/Style";

interface ThemeContext {
  theme: DefaultTheme;
  changeColors: (colors: Record<string, string>) => void;
}

interface ThemeProps {
  style?: IStyle;
}

export const ThemeContext = React.createContext<ThemeContext | undefined>(undefined);

export const useTheme = () => {
  const context = React.useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

const Theme: React.FC<ThemeProps> = ({ children, style }) => {
  const [theme, setTheme] = useState<DefaultTheme>({ breakpoints, colors, fontSizes, fonts, primaryTheme });
  const changeColors = (newColors: Record<string, string>) =>
    setTheme({ ...theme, colors: { ...theme.colors, ...newColors } });

  useEffect(() => {
    if (isNil(style) || isEmpty(style.lessCode)) {
      changeColors(getThemeDefaultColor());
      return;
    }

    changeColors(getThemeColorsFromLessString(style.lessCode));
  }, [style?.lessCode]);

  return (
    <ThemeProvider theme={theme}>
      <ThemeContext.Provider value={{ theme, changeColors }}>{children}</ThemeContext.Provider>
    </ThemeProvider>
  );
};

const mapStateToProps = (state: IState) => ({
  style: state.App._.organization?.style,
});

export default connect(mapStateToProps)(Theme);
